// Tipografia de la plataforma (Jose 2026-10-10): Segoe UI en Windows y
// Open Sans en todo lo demas ("para Mac y Android, que la letra sea Open
// Sans"). Segoe UI va primero: en Windows existe y gana, y el navegador NO
// baja Open Sans porque nunca la necesita. En Mac, Android e iPhone no hay
// Segoe UI, asi que cae a Open Sans, que App.css trae de Google Fonts.
// Unica fuente de verdad para los estilos inline; App.css e index.css
// repiten la misma lista porque CSS no puede importar esto.
export const FONT_FAMILY = "'Segoe UI', 'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Arial, sans-serif";
